import { render, staticRenderFns } from "./packingGroup.vue?vue&type=template&id=db6cc6f0&"
import script from "./packingGroup.vue?vue&type=script&lang=js&"
export * from "./packingGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports